import React from 'react';
import router from 'next/router';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { NAVIGATION_PROP } from '@root/src/hooks/useNavigationHistory';
import getRoute from '@root/src/services/routeList';
import { mediaBreakpoint } from '@services/responsiveProvider';
import PageTitle from '@features/ui/components/PageTitle';
import { selectSerieDetail } from '@features/serieDetail/slices/serieDetailServerSlice';
import SerieHeaderBanner from '@features/serieDetail/components/SerieHeaderBanner';
import SerieTabs from '@features/serieDetail/components/SerieTabs';
import SerieLabel from '@features/ui/components/SerieLabel';
import { selectNavigationHistoryUrl } from '@features/ui-layout/slices/uiLayoutSlice';

type SerieHeaderProps = {
  className?:string;
};

const SerieHeader = ({ className }: SerieHeaderProps) => {
  const serie = useSelector(selectSerieDetail);
  const lastNonSeriePage = useSelector(selectNavigationHistoryUrl(NAVIGATION_PROP.lastNonSeriePage));

  const handleBackClick = () => {
    router.push(lastNonSeriePage ?? getRoute.events().list({}));
  };

  return (
    <div className={className}>
      <Header>
        <StyledTitle
          title={serie.name}
          backFunction={handleBackClick}
        />
        {serie.isChampionship && <SerieLabel />}
      </Header>

      {serie.imageCover && <SerieHeaderBanner />}

      <SerieTabs />
    </div>
  );
};

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  margin-top: 20px;
  margin-bottom: 32px;
`;

const StyledTitle = styled(PageTitle)`
  ${mediaBreakpoint.tablet} {
    max-width: calc(100% - 130px);
  } 
  ${mediaBreakpoint.mobile} {
    max-width: 100%;
  }
  
`;

export default SerieHeader;
